/**
 * Phase 66 Plan 04 — Full `/api/v1/users` endpoint catalog.
 *
 * Plan 03 added only the list call; Plan 04 extends with per-circuit
 * lists (Phase 57 CIRCUITO-12 drilldown).
 *
 * @see PATTERNS.md §API endpoints catalog
 */

import { apiGet } from "./client";
import type { User } from "@/types/api";

/** GET /api/v1/users (optionally scoped by ?circuit_id=). */
export const listUsers = (circuitId?: string | null): Promise<User[]> => {
  const qs = circuitId ? `?circuit_id=${encodeURIComponent(circuitId)}` : "";
  return apiGet<User[]>(`/users${qs}`);
};

/** GET /api/v1/circuits/{circuit_id}/users — Phase 57 sub-resource. */
export const listCircuitUsers = (circuitId: string): Promise<User[]> =>
  apiGet<User[]>(`/circuits/${encodeURIComponent(circuitId)}/users`);
